<template>
    <div>
        <button class="voice-lesson" v-if="type !== 'evaluate'" v-on:click="playVoice" :disabled="Boolean(disabled)">
            <span class="lesson-voice-control pause" ref="button"></span>
        </button>
        <button class="voice-player" v-else v-bind:style="{width:  ((time/30) * 100) + 80 + 'px' }"
            v-on:click="playVoice" :disabled="Boolean(disabled)">
            <span class="voice-control pause" ref="button"></span>
            <span class="voice-time">{{`${time}s`}}</span>
        </button>
        <audio :src="url" preload="none" ref="audio"></audio>
    </div>
</template>
<script>
    export default {
        props: {
            type: {},
            url: {},
            time: {},
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                voice: null,
                button: null
            }
        },
        methods: {
            playVoice: function () {
                let _this = this
                let baseButtonClass = this.type === 'evaluate' ? 'voice-control' : 'lesson-voice-control'
                let voiceList = Array.prototype.slice.call(document.getElementsByTagName('audio'))
                let voiceButton = Array.prototype.slice.call(document.getElementsByClassName('voice-control'))
                let lessonList = Array.prototype.slice.call(document.getElementsByClassName('lesson-voice-control'))
                if (this.voice.paused) {
                    voiceList.forEach((v) => {
                        v.pause()
                    })
                    voiceButton.forEach((v) => {
                        v.className = 'voice-control pause'
                    })
                    lessonList.forEach((v) => {
                        v.className = 'lesson-voice-control pause'
                    })
                    this.voice.play()
                    this.button.className = `${baseButtonClass} play`
                } else {
                    this.voice.pause()
                    this.button.className = `${baseButtonClass} pause`
                }
                this.voice.onended = function () {
                    _this.button.className = `${baseButtonClass} pause`
                }
            }
        },
        mounted: function () {
            this.voice = this.$refs.audio
            this.button = this.$refs.button
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" scoped>
    button {
        outline: none;
        background: #fff;
    }

    .voice-player {
        max-width: 184px !important;
        height: 40px;
        padding: 11.5px 17.5px;
        background: #fff;
        border: 1px solid #E4E9EE;
        border-radius: 100px;
        box-sizing: border-box;
        min-width: 80px !important;
        .voice-control {
            display: inline-block;
            width: 12px;
            height: 12px;
            margin-right: 8.5px;
        }
        font-size: 14px;
        color: #767676;
    }

    .voice-lesson {
        position: relative;
        width: 43px;
        height: 43px;
        border-radius: 50%;
        border: 1px solid #E4E9EE;
        .lesson-voice-control {
            display: inline-block;
            position: absolute;
            width: 14px;
            height: 14px;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }

    .play {
        background: url("../assets/images/play.png") no-repeat center;
        background-size: contain;
    }

    .pause {
        background: url("../assets/images/pause.png") no-repeat center;
        background-size: contain;
    }
</style>



// WEBPACK FOOTER //
// src/components/VoicePlayer.vue